var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.0473C13.1 8.0473 14 7.15797 14 6.07101C14 4.98405 13.1 4.09473 12 4.09473C10.9 4.09473 10 4.98405 10 6.07101C10 7.15797 10.9 8.0473 12 8.0473ZM12 10.0236C10.9 10.0236 10 10.9129 10 11.9999C10 13.0868 10.9 13.9762 12 13.9762C13.1 13.9762 14 13.0868 14 11.9999C14 10.9129 13.1 10.0236 12 10.0236ZM12 15.9524C10.9 15.9524 10 16.8418 10 17.9287C10 19.0157 10.9 19.905 12 19.905C13.1 19.905 14 19.0157 14 17.9287C14 16.8418 13.1 15.9524 12 15.9524Z",
    fill: "#13214E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three_dots.565a15f08aa9523b4424c96f32c2a99d.svg";
export { ForwardRef as ReactComponent };